export default __webpack_public_path__ + "static/media/Chile_Global.cf3506b2.svg";